import React, { useState } from 'react';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useNavigate } from 'react-router-dom';
import XIcon from '@mui/icons-material/X';

const actions = [
  { icon: <WhatsAppIcon />, name: 'WhatsApp', path: 'https://api.whatsapp.com/send?phone=9394322300' },
  { icon: <FacebookIcon />, name: 'Facebook', path: 'https://www.facebook.com/people/DBasesolutionspvtltd/61560310641678/' },
  { icon: <InstagramIcon />, name: 'Instagram', path: 'https://www.instagram.com/dbasesolutionspvtltd/' },
  { icon: <XIcon />, name: 'X', path: 'https://x.com/DbsPvtItd?t=dxL2jNKK8f-1vPHwoym7zA&s=09' },
  
];

const SpeedDialComponent = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (path === 'chat') {
      setIsChatOpen(!isChatOpen);
    } else if (path.startsWith('http')) {
      window.open(path, '_blank');
    } else {
      navigate(path);
    }
  };

  return (
    <>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          '& .MuiSpeedDial-fab': {
            backgroundColor: 'rgb(255, 81, 0);',
            '&:hover': {
              backgroundColor: 'rgb(255, 81, 0);',
            },
          },
        }}
        icon={<SpeedDialIcon sx={{ color: '#fff', background: 'rgb(255, 81, 0);' }} />}
        direction="up"
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => handleClick(action.path)}
          />
        ))}
      </SpeedDial>
    </>
  );
};

export default SpeedDialComponent;
